import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectSegmentSelected = createSelector(
  [(store: RootState) => store.locationShow.segmentSelected],
  (data) => data
);
